import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Studio } from 'src/app/models/studio';
import { StudioService } from 'src/app/services/studio.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditStudioComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'studi',
  templateUrl: './studi.component.html',
  styleUrls: ['./studi.component.scss']
})
export class StudiComponent implements OnInit {


  headingText: string = 'Studi';

  relations: string[] = ['comune', 'comune.provincia', 'firmatario'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Gruppo',
        internalName: 'gruppo',

        sortDisabled: true,
        displayFunction: model => model.gruppo?.nome,
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Telefono',
        internalName: 'tel',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Cellulare',
        internalName: 'cell',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Fax',
        internalName: 'fax',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Email',
        internalName: 'email',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Firmatario',
        internalName: 'firmatario',
        type: 'string',
        displayFunction: model => model?.firmatario?.humanIdentifier

      }
    ),
  ];
  constructor(public studioService: StudioService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<StudiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona uno studio';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (studio: Studio) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare lo studio ${studio.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.studioService.delete(studio);
          this.toast.success('Studio eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione studio fallita.", "Errore!");
    }
  }



  editFunction = async (studio: Studio) => {
    try {
      let dialogRef = this.dialog.open(EditStudioComponent, { data: studio });
      dialogRef.afterClosed().subscribe(async (data: Studio) => {
        if (data) {

          Object.assign(studio, data);
          studio["firmatario_id"] = data.firmatario.id;
          console.log(studio);
          await this.studioService.edit(studio);

          this.toast.success('Studio modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica studio fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditStudioComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(studio?: Studio) {
    if (studio) {
      try {
        await this.studioService.create(studio)
        this.toast.success('Studio creato!')
      }
      catch (e) {
        this.toast.error('Creazione studio fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
